'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _jobRequestsFilter = require('./job-requests-filter.html');

var _jobRequestsFilter2 = _interopRequireDefault(_jobRequestsFilter);

var _jobRequestsFilter3 = require('./job-requests-filter.controller');

var _jobRequestsFilter4 = _interopRequireDefault(_jobRequestsFilter3);

require('./job-requests-filter.styl');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var jobRequestsFilterComponent = {
  restrict: 'E',
  bindings: {
    applyFilters: '&'
  },
  template: _jobRequestsFilter2.default,
  controller: _jobRequestsFilter4.default,
  controllerAs: 'vm'
};

exports.default = jobRequestsFilterComponent;


/** WEBPACK FOOTER **
 ** ./client/app/common/Components/job-requests-filter/job-requests-filter.component.js
 **/